import {CopilotWidgetType} from 'common/src/modules/shared/copilot/copilot.enums';
import {
  ConditionSignalTypeName,
  RelatedCardType,
} from 'common/src/modules/excelToCampaign/excelToCampaign.enums';
import {z} from 'zod';

const excelToCampaignSummaryItemSchema = z.object({
  header: z.string(),
  cardType: z.nativeEnum(RelatedCardType),
  signal: z
    .object({
      name: z.string(),
      key: z.string(),
    })
    .nullable(),
});

const excelToCampaignSummaryContentPartSchema = z
  .object({
    type: z.literal(CopilotWidgetType.ExcelToCampaignSummary),
    content: z.array(excelToCampaignSummaryItemSchema),
  })
  .describe('content part for excel to campaign summary');

const columnToSignalMappingSchema = z.object({
  header: z.object({
    name: z.string().describe('The excel header name'),
    columnIndex: z.number().describe('The index of the column in the excel file'),
  }),
  columnValuesType: z
    .nativeEnum(ConditionSignalTypeName)
    .describe('The type of values in the column. Correlates to signal type name.'),
  signalKey: z.string().describe('The key of the campaign signal this header maps to'),
  reason: z.string().describe('The reason this header is a candidate for mapping to the signal'),
  isFixedByUser: z
    .boolean()
    .describe('Whether the mapping is fixed by the user. Default is false.'),
});

export {excelToCampaignSummaryContentPartSchema, columnToSignalMappingSchema};
